module.exports = __webpack_public_path__ + "static/media/sql_image_presentation.9218964f.png";